import React from 'react';
import Navigation from './navigation.js'

const Header = (props) => {
	return (
		<header className="text-left">
			<Navigation />
		</header>
	);
}

export default Header;
